import {BaseConfig} from "../../infrastructure/config/base-config";
import {PreviousMeetingsWidgetTerms} from "./previous-meetings-widget.terms";

export class PreviousMeetingsWidgetConfig extends BaseConfig {

  static injectables = [PreviousMeetingsWidgetTerms];

  constructor(terms: PreviousMeetingsWidgetTerms){
    super('previousMeetingsWidget', null, terms)
  }
}
